module.exports = __webpack_public_path__ + "media/images/element/high-school-9f50e68438dce7ebd685ebe54919edbf.svg";